import StreamliningDecisions from "../../../../src/components/streamlining/decisions";
import * as React from 'react';
export default {
  StreamliningDecisions,
  React
};